import React, { useContext, useEffect, useMemo } from "react";
import styled from "styled-components";
import UserContext from "../../../contexts/UserContext";
import AppContext from "../../../contexts/AppContext";
import Check from "../../../assets/images/newCheck.png";

const CheckoutItemCardStyles = styled.div`
    .frame-295922844 {
        display: flex;
        flex-direction: row;
        gap: 8px;
        align-items: center;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
        margin-bottom: 16px;
    }
    .chips,
    .chips2 {
        background: var(--buttons-button-secondary, #1c1c1e);
        border-radius: 52px;
        padding: var(--spacings-md, 12px) var(--spacings-lg, 16px);
        display: flex;
        flex-direction: row;
        gap: var(--spacings-sm, 8px);
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        height: 32px;
        position: relative;
        cursor: pointer;
    }
    .chips {
        background: var(--buttons-button-tertiary, #232832);
    }
    .check {
        flex-shrink: 0;
        width: 16px;
        height: 16px;
        position: relative;
        overflow: visible;
    }
    .blue-polo {
        color: var(--text-text-primary, #ffffff);
        font-family: var(--buttons-buttontext-font-family, "OpenSans-Regular", sans-serif);
        font-size: var(--buttons-buttontext-font-size, 14px);
        font-weight: var(--buttons-buttontext-font-weight, 400);
        line-height: var(--buttons-buttontext-line-height, 18px);
        position: relative;
    }
`;

const CheckoutCardHeader = ({ selectedOption, setSelectedOption }) => {
    const { shopperBagItem } = useContext(AppContext);

    const getBackgroundColor = option => {
        return selectedOption === option ? "rgba(35, 40, 50, 1)" : "#1C1C1E";
    };

    const deliveryFlags = useMemo(() => {
        let flags = {
            isPickupFound: false,
            isCourierFound: false,
            isShippingFound: false
        };

        shopperBagItem?.map(item => {
            if (item?.deliveryOption.toLowerCase() === "pickup") flags.isPickupFound = true;
            if (item?.deliveryOption.toLowerCase() === "courier") flags.isCourierFound = true;
            if (item?.deliveryOption.toLowerCase() === "shipping") flags.isShippingFound = true;
        });

        return flags;
    }, [shopperBagItem]);

    return (
        <>
            {shopperBagItem?.length > 1 && (
                <CheckoutItemCardStyles>
                    <div className="frame-295922844">
                        <div
                            className="chips"
                            onClick={() => setSelectedOption("All")}
                            style={{ backgroundColor: getBackgroundColor("All") }}>
                            {selectedOption === "All" && <img className="check" src={Check} alt="check" />}
                            <div className="blue-polo">All</div>
                        </div>

                        {deliveryFlags?.isPickupFound && (
                            <div
                                className="chips2"
                                onClick={() => setSelectedOption("Pickup")}
                                style={{ backgroundColor: getBackgroundColor("Pickup") }}>
                                {selectedOption === "Pickup" && <img className="check" src={Check} alt="check" />}
                                <div className="blue-polo">Pickup</div>
                            </div>
                        )}
                        {deliveryFlags?.isCourierFound && (
                            <div
                                className="chips2"
                                onClick={() => setSelectedOption("Courier")}
                                style={{ backgroundColor: getBackgroundColor("Courier") }}>
                                {selectedOption === "Courier" && <img className="check" src={Check} alt="check" />}
                                <div className="blue-polo">Courier</div>
                            </div>
                        )}

                        {deliveryFlags?.isShippingFound && (
                            <div
                                className="chips2"
                                onClick={() => setSelectedOption("Shipping")}
                                style={{ backgroundColor: getBackgroundColor("Shipping") }}>
                                {selectedOption === "Shipping" && <img className="check" src={Check} alt="check" />}
                                <div className="blue-polo">Shipping</div>
                            </div>
                        )}
                    </div>
                </CheckoutItemCardStyles>
            )}
        </>
    );
};

export default CheckoutCardHeader;
